// extracted by mini-css-extract-plugin
export default {"wrapper":"Graphs_wrapper__8Y4Se","controls":"Graphs_controls__pyl7+","graph":"Graphs_graph__AyYSU","graphpadding":"Graphs_graphpadding__K5Pbh"};